import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { SkeletonBase } from '~/ui/core/skeleton/Skeleton';

import { agentLibraryTranslationKeys as keys } from './recommended-agents-translations';

/** Two sections and their rows as placeholders while the attributions load. */
export const AgentAttributionsSkeleton: FunctionComponent = () => {
    const translate = useTranslate();

    return (
        <div aria-label={translate(keys.attributionsLoading)} className="flex flex-col gap-m" role="status">
            {[0, 1].map((section) => (
                <div
                    key={section}
                    className="flex flex-col gap-xxs overflow-hidden rounded-xl bg-surface-hover p-xxs shadow-sm"
                >
                    <SkeletonBase className="mx-m my-xs h-4 w-24" />
                    <div className="flex flex-col overflow-hidden rounded-lg bg-surface-raised shadow-sm">
                        {[0, 1].map((row) => (
                            <div
                                key={row}
                                className="flex items-center justify-between gap-m px-m py-m [&:not(:first-child)]:shadow-[inset_0_1px_0_var(--color-border-soft)]"
                            >
                                <div className="flex flex-col gap-xxs">
                                    <SkeletonBase className="h-4 w-40" />
                                    <SkeletonBase className="h-3 w-32" />
                                </div>
                                <div className="flex flex-col items-end gap-xxs">
                                    <SkeletonBase className="h-4 w-20" />
                                    <SkeletonBase className="h-3 w-24" />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};
